import { TsuLoading } from '@/common/components';
import { AppLayout } from '@/layouts/AppLayout';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { IPunchoutWaivenet, IPunchoutWaivenetVars } from '../../PunchoutInterface';

const WAIVENET_PUNCHOUT_PRODMANA_MUTATION = gql`
  mutation ($destination: String!, $returnURL: String!) {
    punchoutWaivenetProdMana(input: { destination: $destination, returnURL: $returnURL }) {
      success
      link
    }
  }
`;

export function ProductManagementPunchout() {
  const [punchoutWaivenetProdManaMutation, { data, loading }] = useMutation<
    IPunchoutWaivenet,
    IPunchoutWaivenetVars
  >(WAIVENET_PUNCHOUT_PRODMANA_MUTATION, {
    variables: { destination: 'prodManager', returnURL: 'https://test.com.au' },
  });

  useEffect(() => {
    punchoutWaivenetProdManaMutation();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.origin === 'https://staging.waivenet.com.au') {
        try {
          console.log('[DocumentManager] Event data:', event.data);
        } catch (err) {
          console.error(`[DocumentManager] Error parsing message: ${event.data.toString()}`);
        }
      }
    };
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <AppLayout title="Product Management">
      <TsuLoading loading={loading}>
        <iframe
          id="punchout"
          // @ts-ignore
          src={data?.punchoutWaivenetProdMana.link}
          style={{ width: '100%' }}
          height={1080}
        ></iframe>
      </TsuLoading>
    </AppLayout>
  );
}
